<template>
	<div class="container-fluid conteudo">
		<div>
			<div class="fl-cabecalho" v-if="exibeCabecalho">
				<div class="row">
					<div class="col-lg-4 col-xs-12">
						<i class="icon icon-novo_cadastro"></i>
						<h3 v-if="_idCliente != 25 && _idCliente != 41">
							{{ centrodeCusto.toUpperCase() }}
						</h3>
						<h3 v-if="_idCliente == 25">
							{{ _traducao('global', 'centroDeCustos').toUpperCase() }}
						</h3>
						<h3 v-if="_idCliente == 41">
							{{ _traducao('global', 'clienteSolicitante').toUpperCase() }}
						</h3>
						<h4
							@click="_exibeSub('ad')"
							style="cursor: pointer"
							:style="ehModal ? 'pointer-events: none' : ''"
						>
							{{ _traducao('menu', 'menuAdministracao').toUpperCase() }}
							{{ _traducao('menu', 'menuGeral').toUpperCase() }}
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</h4>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<div class="text-center" v-show="load">
						<flCarregando />
					</div>
				</div>
			</div>

			<div
				class="row"
				v-show="!load"
				:style="{'margin-top': exibeCabecalho ? '20px' : '8px'}"
			>
				<!-- tabela com os cargos -->
				<div class="col-xs-6">
					<!-- busca -->
					<div class="row">
						<div class="col-md-8">
							<i
								class="fa fa-search icone-busca"
								style="top: 8px"
								aria-hidden="true"
							></i>
							<input
								type="text"
								style="padding-left: 25px"
								:placeholder="_traducao('global', 'buscar')"
								@keyup="filtra()"
								v-model="tabela.busca"
								class="form-control"
							/>
						</div>

						<div class="col-xs-4">
							<button
								type="button"
								@click="exibirNovo"
								class="btn btn-block pull-right btn-default"
							>
								<i
									class="icon-solicitacao_nova_solicitacao"
									style="margin-top: 1px; margin-right: 3px; float: left"
								></i>
								{{ _traducao('global', 'novo') }}
							</button>
						</div>
					</div>
					<div
						class="col-xs-12 col-md-12"
						style="margin-top: 8px; margin-bottom: 5px; padding-right: 0px"
					>
						<button
							type="button"
							class="btn btn-xs btn-default pull-right"
							:class="{
								'btn-danger': orgaosApoiadoDesativados == true,
								'col-xs-12': _isMobile
							}"
							@click="
								orgaosApoiadoDesativados = !orgaosApoiadoDesativados
								getOrgaosApoiadoDesativados()
							"
							:style="{'margin-top': _isMobile ? '5px' : ''}"
						>
							<i
								v-if="orgaosApoiadoDesativados == false"
								class="fa fa-fw fa-circle-o"
							></i>
							<i
								v-if="orgaosApoiadoDesativados == true"
								class="fa fa-fw fa-check-circle"
							></i>
							{{ _traducao('global', 'orgaosApoiadosDesativados') }}
						</button>
					</div>
					<!-- lista -->
					<div class="row" style="margin-top: 8px">
						<div class="col-xs-12">
							<table class="table table-lista table-striped table-hover">
								<thead>
									<tr>
										<th style="width: 65%">
											<span v-show="_idCliente != 25"
												>{{
													_traducao('menuAGtipoGuarnicao', 'menuAGgSigla')
												}}
												- {{ _traducao('global', 'nome') }}</span
											>
											<span v-show="_idCliente == 25">
												{{ _traducao('global', 'descricao') }}<br />
												{{ _traducao('global', 'centroDeCustos') }}
											</span>
										</th>
										<th v-show="_idCliente != 25" style="width: 20%">
											{{
												_traducao(
													'menuMsolicitaManutencao',
													'menuMsolicitaNivel'
												)
											}}
										</th>
										<th class="text-center" v-if="orgaosApoiadoDesativados">
											{{ _traducao('global', 'reativar') }}
										</th>
										<th class="text-center" v-if="!orgaosApoiadoDesativados">
											{{ _traducao('global', 'excluir') }}
										</th>
										<th class="text-center">
											{{ _traducao('global', 'editar') }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, index) in tabela.listaChunk[
											tabela.pagination.currentPage - 1
										]"
										:key="index"
									>
										<td>
											{{ item.sigla }}<br />
											<small>{{ item.descricao }}</small>
										</td>
										<td v-if="_idCliente != 25">{{ item.nivel }}</td>

										<td class="text-center" v-if="orgaosApoiadoDesativados">
											<a
												href="#"
												@click.prevent="reativar(item)"
												style="margin-left: 6px; margin-right: 6px"
											>
												<i class="fa icon-check" style="font-size: 20px"></i>
											</a>
										</td>
										<td class="text-center" v-if="!orgaosApoiadoDesativados">
											<a
												href="#"
												@click.prevent="excluir(item)"
												style="margin-left: 6px; margin-right: 6px"
											>
												<i class="fa icon-lixeira" style="font-size: 20px"></i>
											</a>
										</td>
										<td class="text-center">
											<a
												href="#"
												@click.prevent="editar(item)"
												style="margin-left: 6px; margin-right: 6px"
											>
												<i class="fa icon-editar" style="font-size: 20px"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<!-- paginacao -->
					<div class="row">
						<div class="col-md-12 text-center">
							<nav>
								<ul
									class="pagination"
									:class="{'pagination-sm': !_isMobile}"
									style="margin: 0px"
								>
									<li :class="{disabled: tabela.pagination.currentPage == 1}">
										<a href="#" @click.prevent="previous">
											<span aria-hidden="true">
												<i class="fa fa-angle-left" aria-hidden="true"></i>
											</span>
										</a>
									</li>
									<li
										v-for="(item, idxPg) in tabela.pagination.pageNumbers"
										:key="idxPg"
										:class="{active: item == tabela.pagination.currentPage}"
									>
										<a href="#" @click.prevent="page(item)">{{ item }}</a>
									</li>
									<li
										:class="{
											disabled:
												tabela.pagination.currentPage ==
												tabela.pagination.totalPages
										}"
									>
										<a href="#" @click.prevent="next">
											<span aria-hidden="true"
												><i class="fa fa-angle-right" aria-hidden="true"></i
											></span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>

				<!-- formulário -->
				<div class="col-xs-6" v-show="exibirForm">
					<div class="row">
						<div class="col-xs-6" style="color: #555; font-size: 14px">
							<h3 v-show="form.id != 0" style="margin: 0px">
								<i
									class="icon icon-solicitacao_editar_solicitacao"
									style="margin-top: 1px; float: left; margin-right: 7px"
								></i>
								{{ _traducao('global', 'editar') }}
							</h3>

							<h3 v-show="form.id == 0" style="margin: 0px">
								<i
									class="icon icon-solicitacao_nova_solicitacao"
									style="margin-top: 1px; float: left; margin-right: 7px"
								></i>
								{{ _traducao('global', 'novo') }}
							</h3>
						</div>

						<div class="col-xs-6">
							<button
								type="button"
								@click="exibirForm = false"
								class="btn pull-right btn-xs btn-default"
							>
								<i class="fa fa-times"></i> {{ _traducao('global', 'fechar') }}
							</button>
						</div>
					</div>

					<div class="row">
						<div class="col-xs-12">
							<hr style="margin-top: 2px; margin-bottom: 10px" />
						</div>
					</div>

					<!-- descricao -->
					<div class="row">
						<div
							class="col-xs-12 form-group"
							:class="{'has-error': erro.descricao != ''}"
						>
							<label>
								<span class="no-print">* </span>
								<span v-if="_idCliente == 25"
									>{{ _traducao('global', 'descricao') }}:</span
								>
								<span v-else>{{ _traducao('global', 'nome') }}:</span>
							</label>
							<input
								type="text"
								v-model="form.descricao"
								@blur="validaDescricao"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="erro.descricao != ''">
								{{ erro.descricao }}
							</p>
						</div>
					</div>

					<div class="row">
						<div
							class="col-xs-6 form-group"
							:class="{'has-error': erro.sigla != ''}"
						>
							<label>
								<span class="no-print">* </span>
								<span v-if="_idCliente == 25">
									{{ _traducao('global', 'centroDeCustos') }}:
								</span>
								<span v-else>
									{{ _traducao('menuAGtipoGuarnicao', 'menuAGgSigla') }}:
								</span>
							</label>
							<input
								type="text"
								v-model="form.sigla"
								@blur="validaSigla"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="erro.sigla != ''">
								{{ erro.sigla }}
							</p>
						</div>

						<div
							class="col-xs-12 form-group"
							:class="{
								'has-error': erro.nivel != '',
								'col-xs-6': _idCliente != 25
							}"
							v-show="_idCliente != 25"
						>
							<label
								><span class="no-print">* </span
								>{{
									_traducao('menuMsolicitaManutencao', 'menuMsolicitaNivel')
								}}:</label
							>
							<select v-model.trim="form.nivel" class="form-control input-sm">
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option value="Federal">Federal</option>
								<option value="Estadual">Estadual</option>
								<option value="Municipal">Municipal</option>
								<option value="Privado">Privado</option>
							</select>
							<!--<input type="text" v-model="form.nivel" class="form-control input-sm"> -->
							<p class="help-block" v-show="erro.nivel != ''">
								{{ erro.nivel }}
							</p>
						</div>
						<div
							:class="{
								'has-error': erro.orgao != ''
							}"
							class="col-xs-12 form-group"
						>
							<label
								><span class="no-print">* </span
								>{{ _traducao('global', 'orgao') }}:</label
							>
							<select v-model="form.id_orgao" class="form-control input-sm">
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option v-for="{id, descricao} in orgaos" :key="id" :value="id">
									{{ descricao }}
								</option>
							</select>
							<p class="help-block" v-show="erro.orgao != ''">
								{{ erro.orgao }}
							</p>
						</div>
					</div>

					<!-- botao salvar -->
					<div class="row">
						<div class="col-xs-6">
							<span class="pull-left no-print">
								<i class="fa fa-info-circle"></i>
								{{ referenciaCustoEmpresa }}
							</span>
						</div>
						<div class="col-xs-6">
							<span class="label label-info pull-left no-print">
								<i class="fa fa-info-circle"></i>
								{{ _traducao('global', 'obrigatorio') }}
							</span>

							<button
								type="button"
								@click="clickSalva"
								class="btn btn-success pull-right"
							>
								<i class="fa fa-check" aria-hidden="true"></i>
								{{ _traducao('global', 'salvar').toUpperCase() }}
							</button>
						</div>
					</div>
				</div>

				<!-- info -->
				<div class="col-xs-6" v-show="!exibirForm">
					<h3 class="text-center">
						<i class="fa fa-info-circle"></i>
						{{ _traducao('menuAGnovoCargo', 'menuAGtexto1') }} <br /><br />
						{{ _traducao('global', 'ou') }} <br /><br />
						{{ _traducao('menuAGnovoCargo', 'menuAGtexto2') }}
						<i class="fa icon-editar"></i>
						{{ _traducao('menuAGnovoCargo', 'menuAGtexto3') }}
					</h3>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $tabela from '../../../../mixins/tabela.js'

export default {
	name: 'OrgaosApoiadosMain',
	mixins: [$tabela],
	props: {
		exibeCabecalho: {
			type: Boolean,
			default: true
		},

		ehModal: {
			type: Boolean,
			default: false,
			required: false
		}
	},

	data() {
		return {
			load: false,
			exibirForm: false,
			modelos: [],
			disabledBTN: false,
			orgaosApoiadoDesativados: false,
			listaOrgaosApoiadosDesativados: [],
			orgaosApoiadosAtivos: [],

			auxDescricao: '',
			centrodeCusto: '',
			salvaCentroCusto: '',
			deletaCentroCusto: '',
			referenciaCustoEmpresa: '',

			form: {
				id: 0,
				id_usuario: 0,
				descricao: '',
				sigla: '',
				nivel: '',
				id_orgao: ''
			},

			orgaos: [],

			erro: {
				descricao: '',
				sigla: '',
				nivel: '',
				orgao: ''
			},

			passouD: true,
			passouS: true,

			tabela: {
				lista: [],
				listaChunk: [],

				columns: ['id', 'descricao', 'sigla'],
				inverse: 'asc',
				busca: '',
				bouse: false,

				pagination: {
					currentPage: 1,
					totalPages: 0,
					totalItens: 0,
					pageNumbers: [],
					perPage: 10
				}
			}
		}
	},

	mounted() {
		this.getLista()
		this.form.id_usuario = Number($sessao.getId())
		this._axios('/Orgao/get_orgao', 'get', {
			callback: ({lista}) => {
				this.orgaos = lista
			}
		})
	},

	created() {
		this._providerBaseOperacional((lista) => (this.bases = lista))
		this.form.id_usuario = $sessao.getId()
		this.utilizaTrigrama = $cliente.get('utiliza_trigrama') === '1'
		this.parametros()
	},

	methods: {
		atualizaLista(item) {
			var achou = false

			for (var i = 0, len = this.tabela.lista.length; i < len; i++) {
				if (this.tabela.lista[i].id == item.id) {
					this.$set(this.tabela.lista, i, item)
					this.tabela.lista[i] = item

					bus.$emit('exibir-notificacao', {
						type: 'success',
						text: this._traducao('global', 'centroCustoAtualizado')
					})

					achou = true
					break
				}
			}

			if (achou == false) {
				bus.$emit('exibir-notificacao', {
					type: 'success',
					text: this.salvaCentroCusto
				})
				this.tabela.lista.push(item)
			}

			this.exibirForm = false
			this.limpaForm()

			this.filtraCore()
		},

		exibirNovo() {
			this.exibirForm = true
			this.limpaForm()
		},

		excluir(item) {
			let _label = this.centrodeCusto + ' ?'

			var texto =
				'<h3>Deseja excluir esse ' +
				_label +
				"<br/> <span class='text-danger'> " +
				item.descricao +
				' </span> </h3>'
			this._modalExcluir(
				(retorno) => {
					if (retorno.excluir) {
						this.deleta(retorno.obj)
					}
				},
				item,
				texto,
				this._traducao('global', 'excluir').toUpperCase()
			)
		},

		deleta(item) {
			bus.$emit('load-in', {text: 'Excluindo'})

			this._httpGet('/Orgao_apoiado/excluir/' + item.id, (retorno) => {
				bus.$emit('load-out')
				if (retorno._request) {
					if (retorno._status) {
						var index = _.findIndex(this.tabela.lista, (o) => {
							return o.id == item.id
						})

						if (index >= 0) {
							this.orgaosApoiadosAtivos.splice(index, 1)
							this.tabela.lista.splice(index, 1)
							window.bus.$emit('atualiza-dados-oap')
						}
						this.exibirForm = false
						this.tabela.busca = ''
						this.limpaForm()

						bus.$emit('exibir-notificacao', {
							type: 'success',
							text: this.deletaCentroCusto
						})

						this.listaOrgaosApoiadosDesativados.push(item)

						this.filtraCore()
					} else {
						bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: retorno.mensagem
						})
					}
				}
			})
		},

		reativar(item) {
			let _label = this.centrodeCusto + ' ?'

			var texto =
				'<h3>Deseja reativar esse ' +
				_label +
				"<br/> <span class='text-success'> " +
				item.descricao +
				' </span> </h3>'
			this._modalReativar(
				(retorno) => {
					if (retorno.reativar) {
						this.reativarItem(retorno.obj)
					}
				},
				item,
				texto,
				'Reativar'
			)
		},

		reativarItem(item) {
			bus.$emit('load-in', {text: 'reativar'})

			this._httpGet('/Orgao_apoiado/reativar/' + item.id, (retorno) => {
				bus.$emit('load-out')
				if (retorno._request) {
					if (retorno._status) {
						var index = _.findIndex(this.tabela.lista, (o) => {
							return o.id == item.id
						})

						if (index >= 0) {
							this.listaOrgaosApoiadosDesativados.splice(index, 1)
							this.tabela.lista.splice(index, 1)
							window.bus.$emit('atualiza-dados-oap')
						}
						this.exibirForm = false
						this.limpaForm()

						bus.$emit('exibir-notificacao', {
							type: 'success',
							text: this._traducao('global', 'reativadoComSucesso')
						})
						this.tabela.busca = ''
						this.orgaosApoiadosAtivos.push(item)
						this.tabela.lista = this.orgaosApoiadosAtivos
						this.orgaosApoiadoDesativados = false
						this.filtraCore()
					} else {
						bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: retorno.mensagem
						})
					}
				}
			})
		},

		validaDescricao() {
			if (this.form.id == 0) {
				this.valida(this.form.descricao, 'D')
			} else {
				if (this.auxDescricao.trim() != this.form.descricao.trim()) {
					this.valida(this.form.descricao, 'D')
				}
			}
		},

		validaSigla() {
			if (this.form.id == 0) {
				this.valida(this.form.sigla, 'S')
			} else {
				if (this.form.sigla != '') {
					this.valida(this.form.sigla, 'S')
				}
			}
		},

		valida(descricao, tipo) {
			this.disabledBTN = true

			let data = {}

			if (tipo == 'D') {
				data.descricao = descricao
			}
			if (tipo == 'S') {
				data.sigla = descricao
			}

			if (data.descricao != '' || data.sigla != '') {
				this._httpPost('/Orgao_apoiado/verifica', data, (retorno) => {
					if (retorno._request) {
						if (retorno.status) {
							if (tipo == 'D') {
								this.erro.descricao = this._traducao(
									'global',
									'voceJaCadastrouItem'
								)
								this.passouD = false
							}

							if (tipo == 'S') {
								this.erro.sigla = this._traducao(
									'global',
									'voceJaCadastrouItem'
								)
								this.passouS = false
							}
						} else {
							if (tipo == 'D') {
								this.erro.descricao = ''
								this.passouD = true
							}

							if (tipo == 'S') {
								this.erro.sigla = ''
								this.passouS = true
							}
						}
					}
				})
			}
		},

		limpaForm() {
			this.form.id = 0
			this.auxDescricao = ''
			this.form.descricao = ''
			this.form.sigla = ''
			this.form.id_orgao = ''

			this.form.nivel = this._idCliente == 25 ? 'Privado' : ''

			this.erro.descricao = ''
			this.erro.sigla = ''
			this.erro.nivel = ''
		},

		getLista() {
			this.load = true
			this._httpGet('/Orgao_apoiado/get', (retorno) => {
				if (retorno._request && retorno._status) {
					this.orgaosApoiadosAtivos = retorno.lista
					this.tabela.lista = retorno.lista
					this.filtraCore()
					this.load = false
				}
			})
		},

		// CLICK EDITAR
		editar(item) {
			this.exibirForm = true
			this.form.id = item.id
			this.form.descricao = item.descricao
			this.form.sigla = item.sigla
			this.form.nivel = item.nivel
			this.form.id_orgao = item.id_orgao
			this.auxDescricao = item.descricao
		},

		clickSalva() {
			if (this.validaForm()) {
				if (this.passouD && this.passouS) {
					bus.$emit('load-in', {text: this._traducao('global', 'salvando')})

					this._httpPost('/Orgao_apoiado/salvar', this.form, (retorno) => {
						bus.$emit('load-out')

						if (retorno._request) {
							this.form.id = retorno.lista[0].id
							this.atualizaLista(retorno.lista[0])
							window.bus.$emit('atualiza-dados-oap')
						}
					})
				} else {
					bus.$emit('exibir-notificacao', {
						type: 'danger',
						text: this._traducao('menuEscala', 'menuEvermelho')
					})
				}
			} else {
				bus.$emit('exibir-notificacao', {
					type: 'danger',
					text: this._traducao('menuEscala', 'menuEvermelho')
				})
			}
		},

		validaForm() {
			var passou = true
			var obrigatorio = this._traducao('global', 'campoObrigatorio')

			if (this.form.descricao.trim() == '') {
				this.erro.descricao = obrigatorio
				passou = false
			}

			if (this.form.sigla.trim() == '') {
				this.erro.sigla = obrigatorio
				passou = false
			}

			if (this.form.nivel.trim() == '') {
				this.erro.nivel = obrigatorio
				passou = false
			} else {
				this.erro.nivel = ''
			}

			if (this.form.id_orgao == '' || this.form.id_orgao == null) {
				this.erro.orgao = obrigatorio
				passou = false
			} else {
				this.erro.orgao = ''
			}
			return passou
		},

		parametros() {
			this._getParametro(52).then((valor) => (this.centrodeCusto = valor))
			this._getParametro(53).then(
				(valor) => (this.referenciaCustoEmpresa = valor)
			)
			this._getParametro(55).then((valor) => (this.salvaCentroCusto = valor))
			this._getParametro(56).then((valor) => (this.deletaCentroCusto = valor))
		},

		getOrgaosApoiadoDesativados() {
			if (this.orgaosApoiadoDesativados) {
				if (this.listaOrgaosApoiadosDesativados.length <= 1) {
					bus.$emit('load-in', {text: 'carregando'})
					this._axios('Orgao_apoiado/get_orgaos_apoiados_desativados', 'get', {
						callback: (response) => {
							if (response._request && response._status) {
								if (response.lista.length > 0) {
									this.listaOrgaosApoiadosDesativados = response.lista
									this.tabela.lista = response.lista
									this.filtraCore()
								} else {
									this.orgaosApoiadoDesativados = false
									bus.$emit('exibir-notificacao', {
										type: 'warning',
										text: 'não existe orgão apoiado desativado'
									})
								}
							}
						},
						finally: () => {
							window.bus.$emit('load-out')
						}
					})
				} else {
					this.tabela.lista = this.listaOrgaosApoiadosDesativados
					this.filtraCore()
				}
			} else {
				this.tabela.lista = this.orgaosApoiadosAtivos
				this.filtraCore()
			}
		}
	}
}
</script>